export const filterInitialState = {
  areas: [],
  areasId: [],
  trees: [],
  treesId: [],
  installations: [],
  installationsId: [],
  variables: [],
  variablesId: [],
  rainAreaId: null,
  healthTreeId: null,
  irrigationTreeId: null,
  tree_sensor_pairs: [],
  sensorId: null,
};

export const intervalPresets = {
  "1d": { "5m": "5 minutes", "15m": "15 minutes", "30m": "30 minutes", "1h": "1 hour" },
  "1w": { "30m": "30 minutes", "1h": "1 hour", "2h": "2 hours", "6h": "6 hours" },
  "1m": { "2h": "2 hours", "6h": "6 hours", "12h": "12 hours", "1d": "1 day" },
  longer: { "1d": "1 day", "7d": "1 week", "30d": "1 month" },
};
